/* Admin 管理员信息 */

export default {
  namespaced: true,

  state: {
    // 管理员信息
    adminInfo: [],
  },

  mutations: {
    /**
     * 设置管理员信息
     * @param {*} state
     * @param {*} adminInfo
     */
    setAdminInfo(state, adminInfo) {
      state.adminInfo = adminInfo;
    },
  },
};
